import { defineMessages } from 'react-intl';

/**
 * The copy of the service strip sections and of the "Coming soon" card of a service with no
 * sign-in in the Music24 app yet.
 *
 * Design: docs/superpowers/design-reference/connector-waitlist/ (a).
 */
export const earlyAccessMessages = defineMessages({
  // design: connector-waitlist a (Connection Deck)
  sectionStreaming: {
    id: 'app.sml.catalog.early_access.section.streaming',
    defaultMessage: 'Streaming services',
  },
  sectionStreamingSignIn: {
    id: 'app.sml.catalog.connections.section.streaming_sign_in',
    defaultMessage: 'Some connect here. The others connect in the MUSIC24 app on your phone.',
  },
  sectionDistributors: {
    id: 'app.sml.catalog.early_access.section.distributors',
    defaultMessage: 'Distributors',
  },
  sectionDistributorsSub: {
    id: 'app.sml.catalog.early_access.section.distributors_sub',
    defaultMessage: 'They deliver your music to the stores and report your earnings.',
  },
  comingSoon: {
    id: 'app.sml.catalog.early_access.coming_soon',
    defaultMessage: 'Coming soon',
  },
  comingSoonNote: {
    id: 'app.sml.catalog.early_access.coming_soon_note',
    defaultMessage: 'Sign-in to {service} comes to the MUSIC24 app soon.',
  },
});
